import { defineMessages } from "react-intl";
import { GeoCheckEventSource } from "../../contract/pam.js";
const localizedGeoCheckEventSource = defineMessages({
  [GeoCheckEventSource.Login]: {
    id: "geoCheckEventSourceMockLogin",
    defaultMessage: "Login"
  },
  [GeoCheckEventSource.Geocomply]: {
    id: "geoCheckEventSourceMockGeocomply",
    defaultMessage: "Geocomply"
  }
});
export {
  localizedGeoCheckEventSource
};
//# sourceMappingURL=geoCheckEventSource.js.map
